<template>
    <div>
        <div class='quantity-container'>
            <button class='change-quantity-button minus-button' @click='removeQuantity'>-</button>
            <input class='quantity-text-box' type="text" id="quantity" name="quantity" v-model='quantity' @blur='blurQuantity'>
            <button class='change-quantity-button plus-button' @click='addQuantity'>+</button>
            <div class='successfully-added-to-bag-container'>
                <Tooltip :tooltip_queue='tooltip_queue'/>
            </div>
            <!-- <div class='out-of-stock-container'>
                <OutOfStockAlert :stock='stock'/>
            </div> -->
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import OutOfStockAlert from '@/ecom/components/cart/OutOfStockAlert.vue';
import Tooltip from '@/ecom/components/popups/Tooltip.vue';

export default {
    components: {OutOfStockAlert, Tooltip},
    props: ['item_quantity', 'product', 'update_cart'],
    emits: ['updatedCartListener', 'updatedQuantityListener'],
    data(){
        return{
            quantity: this.item_quantity,
            stock: {
    
            },
            tooltip_queue: []
        }
    },
    methods:{
        addQuantity(){
            this.quantity++;
            this.updateQuantity();
        },
        removeQuantity(){
            if(this.quantity > 1){
                this.quantity--;
                this.updateQuantity();
            }
        },
        blurQuantity(){
            if(this.quantity == ''){
                this.quantity = 1;
            }
        
            this.updateQuantity()
        },
        updateQuantity(){
            if(this.update_cart){
                this.updateCart();
            }
            else{
                this.$emit('updatedQuantityListener', this.quantity);
            }
        },
        async updateCart(type){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   quantity: this.quantity,
                   type: 'override_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.stock = results.stock;

                if(!results.stock.in_stock){
                    this.quantity = this.item_quantity;
                }

                if(!this.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(this.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + this.stock.left_in_stock  + ' of this item left in stock';
                    } else if(this.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                }

                this.$emit('updatedCartListener', this.product);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.quantity-container{
    display: flex;
    justify-content: center;
}

.change-quantity-button{
    width: 39px;
    height: 39px;
    background-color: white;
    border: solid 1px #adb5bd;
    cursor: pointer;
}

.minus-button{
    border-radius: 4px 0px 0px 4px;
}

.plus-button{
    border-radius: 0px 4px 4px 0px;
}

.quantity-text-box{
    width: 32px;
    padding: 3px;
    text-align: center;
    // border-radius: 4px;
    border-top: solid 1px #adb5bd;
    border-bottom: solid 1px #adb5bd;
    border-left: none;
    border-right: none;
}

.quantity-text-box:focus{
     outline: none;
}

.out-of-stock-container{
    position: absolute;
    margin-top: 40px;
}

</style>